<template>
  <div
    id="page-wrapper"
    class="wrap-container wrap-container--has-margin-bottom customer-service-page"
    role="main"
  >
    <on-page-breadcrumbs :data="breadcrumbs" />
    <h1
      v-if="title || isEditable"
      v-edit="'Title'"
      class="page-title"
    >
      {{ title }}
    </h1>

    <div
      v-if="chatbotTitle"
      class="row-1-noGutter-center_md-2 margin-gutter chatbot-block-wrapper"
    >
      <contact-block
        v-bind="chatbotBlock"
        class="col"
      >
        <a
          v-if="chatbotButtonText"
          class="button button--48"
          @click="openChat"
        >{{ chatbotButtonText }}</a>
      </contact-block>
    </div>

    <div
      v-if="contentArea.length || isEditable"
      v-edit="'ContentBlocks'"
      class="usp-block-wrapper fade-in"
      :style="{ animationDelay: ( (contentArea.length + 2) * (1 / 8)) + 's' }"
    >
      <navigation-group-block
        v-for="block in contentArea"
        :key="block.contentId"
        v-bind="block"
      />
    </div>

    <div
      v-if="accordionBlocks.length || (isEditable && accordionBlocks.length)"
      class="accordion-block-wrapper"
    >
      <sub-heading
        v-if="faqTitle || isEditable"
        :v-edit-heading="'FaqTitle'"
        :heading="faqTitle"
      />

      <in-view
        :threshold="0"
        :threshold-type="'px'"
        class="slide-into-view-transition"
      >
        <div
          v-edit="'AccordionBlocks'"
        >
          <accordion-group
            :items="accordionBlocks | stringify('content')"
            :limit="isEditable ? 0 : accordionShowMoreLimit"
            :tracking-scope="faqTitle"
          />
        </div>
      </in-view>
    </div>

    <sub-heading
      v-if="(alertsTitle && contentArea2.length) || isEditable"
      :v-edit-heading="'AlertsTitle'"
      :heading="alertsTitle"
    />
    <in-view
      :threshold="0"
      :threshold-type="'px'"
      class="slide-into-view-transition"
    >
      <div
        v-if="contentArea2.length || (isEditable && contentArea2.length)"
        v-edit="'contentArea2'"
        class="alert-blocks-wrapper fade-in"
        :style="{ animationDelay: ( (contentArea2.length + 2) * (1 / 8)) + 's' }"
      >
        <alert-block
          v-for="block in contentArea2"
          :key="block.contentId"
          v-bind="block"
        />
      </div>
    </in-view>

    <div
      v-if="contactblocks.length"
      v-edit="'Contactblocks'"
      class="contact-blocks-wrapper"
    >
      <in-view
        :threshold="0"
        :threshold-type="'px'"
        class="slide-into-view-transition"
      >
        <div
          class="row-1-noGutter-center_md-3 margin-gutter"
        >
          <contact-block
            v-for="(item,index) in contactblocks"
            :key="index"
            v-bind="item"
            class="col"
          />
        </div>
      </in-view>
    </div>
  </div>
</template>

<script>
import pageWithNavigation from '@/vue/mixins/pageWithNavigation'
import dataLayer from '@/analytics/dataLayer'

  export default {
    name: "CustomerServicePage",
    mixins: [pageWithNavigation],
    props: {
      title: {
        type: String,
        default: ""
      },
      breadcrumbs: {
        type: Array,
        default: () => []
      },
      contentArea: {
        type: Array,
        default: () => []
      },
      contentArea2: {
        type: Array,
        default: () => []
      },
      alertsTitle: {
        type: String,
        default: ""
      },
      accordionBlocks: {
        type: Array,
        default () {
          return []
        }
      },
      faqTitle: {
        type: String,
        default: ""
      },
      accordionShowMoreLimit: {
        type: Number,
        default: 0
      },
      contactblocks: {
        type: Array,
        default: () => []
      },
      chatbotTitle: {
        type: String,
        default: ""
      },
      chatbotButtonText: {
        type: String,
        default: ""
      },
    },
    computed: {
      chatbotBlock () {
        const data = {
          icon:"Communication/Chatbot",
          title: this.chatbotTitle
        }

        return data
      }
    },
    methods: {
      openChat () {
        this.trackClick()
        window.TeneoWebChat?.call('maximize')
      },
      trackClick () {
        dataLayer.add({
          event: 'chatbotSelect',
          linkName: this.chatbotButtonText,
          linkUrl: ""
        })
      }
    },
  }
</script>

<style lang="scss">
.customer-service-page {
  .page-title {
    @include pageTitle();
  }

  .chatbot-block-wrapper {
    .contact-block-wrapper {
      margin-top: 2rem;
      margin-bottom: 1rem;
    }

    .svg-icon {
      fill: $color-primary-cta;
    }

    .button {
      margin-top: 1rem;
    }
  }

  .alert-blocks-wrapper {
    @include default-margin-bottom();
  }

  .contact-blocks-wrapper {
    .margin-gutter {
      margin-top: -1.5rem;

      @include media-breakpoint-up(md) {
        margin-top: -3.1875rem;
      }
    }

    .contact-block-wrapper {
      @include contactBlock();
    }
  }
}

</style>
